import React, { Fragment, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import Layout from '../Layout/Layout';
import ProtectedRoute from './ProtectRoute';
import Error_page6 from '../Components/Pages/Error/Error_page6';
import Transparentspinner from '../Components/Common/Loader/Transparentspinner';

const LayoutRoutes = () => {

  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component, protected: isProtected, requiredRole, requiredPermission, requiredPlanType, requireSubStatus, requiredModule }, i) => (
          <Route element={<Layout />} key={i}>
            <Route
              path={path}
              element={
                <Suspense fallback={<div><Transparentspinner/></div>}>
                  {
                  (isProtected || requiredPermission || requireSubStatus || requiredModule) ? (
                  <ProtectedRoute
                    component={Component}
                    requiredRole={requiredRole}
                    requiredPermission={requiredPermission}
                    requiredPlanType={requiredPlanType}
                    requireSubStatus={requireSubStatus}
                    requiredModule={requiredModule}
                  />
                  ) : (
                    Component
                  )
                }
                </Suspense>
              }
            />
          </Route>
        ))}
        <Route path="*" element={<Error_page6 />} />

      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;
